import { LinksList } from '../../components/Links'

export const Links = () => {
    return <LinksList full={true} />
}
